export default __webpack_public_path__ + "static/media/vire10.79ec86eb.jpg";